var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4992 26.25C17.9081 26.25 18.251 26.1117 18.5281 25.8352C18.8052 25.5586 18.9437 25.2159 18.9437 24.807C18.9437 24.3982 18.8055 24.0552 18.5289 23.7781C18.2523 23.501 17.9096 23.3625 17.5008 23.3625C17.0919 23.3625 16.749 23.5008 16.4719 23.7773C16.1948 24.0539 16.0562 24.3966 16.0562 24.8055C16.0562 25.2143 16.1945 25.5573 16.4711 25.8344C16.7477 26.1115 17.0904 26.25 17.4992 26.25ZM16.3187 19.5562H18.9437V8.4875H16.3187V19.5562ZM17.5116 35C15.0986 35 12.8309 34.5406 10.7085 33.6219C8.58617 32.7031 6.73021 31.449 5.14062 29.8594C3.55104 28.2698 2.29688 26.4127 1.37813 24.2882C0.459375 22.1637 0 19.8937 0 17.4781C0 15.0626 0.459375 12.7925 1.37813 10.668C2.29688 8.54351 3.55104 6.69375 5.14062 5.11875C6.73021 3.54375 8.58726 2.29688 10.7118 1.37813C12.8363 0.459375 15.1063 0 17.5219 0C19.9374 0 22.2075 0.459375 24.332 1.37813C26.4565 2.29688 28.3062 3.54375 29.8813 5.11875C31.4563 6.69375 32.7031 8.54583 33.6219 10.675C34.5406 12.8042 35 15.0753 35 17.4884C35 19.9014 34.5406 22.1691 33.6219 24.2915C32.7031 26.4138 31.4563 28.2671 29.8813 29.8513C28.3062 31.4355 26.4542 32.6897 24.325 33.6138C22.1958 34.5379 19.9247 35 17.5116 35Z",
    fill: "#F05E5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExclamation);
export default __webpack_public_path__ + "static/media/icon-exclamation.7c9bfcad5d2832f5c9856111f7ed0c14.svg";
export { ForwardRef as ReactComponent };